import { LeaderBoard } from "../../models/LeaderBoard";
import { IRouterId } from "../../models/Utils";
import { Selector } from "../../utils/Selector";

export class LeaderboardSelector extends Selector<LeaderBoard, LeaderBoard["episode_id"], IRouterId>{
    checkDefault = (item: LeaderBoard, index: number) => (index === 0 && this.props.id == null) || (Number(this.props.id) === item.episode_id)

    getLabel = (item: LeaderBoard) => item?.episode_name

    getKey = (item: LeaderBoard) => item.episode_id
}